<div class="col-lg-12">
  <div class="card">
    <div class="card-body">
      <div class="tab-pane" id="divAllocatedarticles">
        <div id="divArtDataList" style="position: relative;">
          <table id="tblVendorAllocatedart" #dataAllocatedTable class="display" style="width:100%;"></table>
          <span id="btn_AddAL" class="Wuedatebtn" (click)="WithDrawnChangeConfirm()" style="display:none;"></span>
          <span id="withdrawnstatus" class="proofingAddbtn" (click)="ShowAllocateddetails()" style="display:none;"></span>
          <span id="btnDropChange" (click)="DueDateChangeConfirm()" style="display:none;"></span>
          <span id="duedatechange" (click)="DuedateChange()" style="display:none;"></span>
        </div>
        <!--popup-->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-md custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <!--popup body start-->
              <div class="modal-body" id="popupbody">
                <div class="row">
                    <div class="col-sm-12" id="Instruction">
                      <div class="form-group">
                        <label for="txt_Remarks">Remarks<em>*</em></label>
                        <textarea rows="5" autocomplete="off" class="form-control" id="txt_Remarks" ></textarea>
                      </div>
                    </div>                 
               </div>
                </div>
                <!--popup body end-->
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                  <button type="button" id="Instructionsave" class="btn btn-outline-success waves-effect waves-light" value="{{ Popupbutton }}" (click)="WithdrawnStatus()"> {{ Popupbutton }} </button>
                </div>
                <!--Loading image-->
                <div id="LoadingImagePopup">
                  <img src="assets/Images/loader.gif" class="imgLoadimg" />
                </div>
              </div>
          </div>
        </div>
        <!--popup end -->
      </div>
    </div>
  </div>
  </div>




